import Row from './row-TEMPLATE_VERSION'

export default Row
